import React from 'react';
import { Box, AspectRatio } from '@chakra-ui/react';

const Video: React.FC = () => (
  <AspectRatio>
    <Box
      as="iframe"
      allow="autoplay; fullscreen"
      scrolling="no"
      width="100%"
      height="auto"
      display="block"
      title="HOVER - Remote Engagement for Contractors"
      src="https://fast.wistia.net/embed/iframe/n3qgsl9owu"
    />
  </AspectRatio>
);

export default Video;
